import MainComponent from "views/find/password/root";

export default function FindPasswordPage(props){
    return (
        <>
            <MainComponent />
        </>
    );
}